<template>
  <div class="main-wrapper">
    <div>
      <!-- <layout-header3></layout-header3> -->
      <layout-header></layout-header>
      <breadcrumb48></breadcrumb48>
      <!-- Page Content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
              <sidebar1></sidebar1>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
              <loader></loader>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-else>
              <div class="row ml-md-3">
                <div class="col-md-12" id="patient_container">
                  <!-- <h3 class="mb-4 mt-2">Fee Payments</h3> -->
                  <div class="appointment-tab">
                    <div class="tab-content">
                      <!-- Receipt Data -->
                      <div class="tab-pane show active" id="today-appointments">
                        <div class="card card-table mb-0">
                          <div class="card-body">
                            <div class="table-responsive">
                              <table class="table table-hover table-center mb-0">
                                <thead>
                                  <tr>
                                    <th style="background-color: #F8F8F8;" class="text-left">Receipt Number</th>
                                    <th style="background-color: #F8F8F8;" class="text-left">Date</th>
                                    <th style="background-color: #F8F8F8;" class="text-left">Doctor</th>
                                    <th style="background-color: #F8F8F8;" class="text-left">Amount</th>
                                    <th style="background-color: #F8F8F8;" class="text-left">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(item, $index) in open_receipt" :key="item.id"
                                  v-show="setOpenReceipts($index)">
                                    <td class="text-left">
                                      <h2 class="table-avatar">
                                        <a href="javascript:void(0);" class="avatar avatar-sm mr-2" @click=""><img
                                            class="avatar-img rounded-circle" v-bind:src="item.image
                                              ? config.base_url_for_Image +
                                              item.image
                                              : loadImg(
                                                'Patient Profile.svg'
                                              )
                                              " alt="User Image" /></a>
                                        <a href="javascript:void(0);" @click="">{{ item.name }}</a>
                                        <!-- </router-link> -->
                                      </h2>
                                    </td>
                                    <td class="text-left">
                                      {{
                                        item.date ? formatDate(item.date) : "-"
                                      }}
                                    </td>
                                    <td class="text-left">
                                      {{ item.practitioner_full_name }}

                                    </td>
                                    <td v-if="item.amount == 0" class="text-left">-</td>
                                    <td v-else class="text-left"> ₹ {{item.amount}}</td>
                                    <td class="text-left">
                                      <a class="btn btn-sm bg-success-light">
                                        <router-link :to="{
                                          name: 'receipt-detail',
                                          params: { receiptId: item.name }
                                        }">
                                         <i class="fas fa fa-eye"></i> View
                                        </router-link>
                                      </a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <h5 v-if="open_receipt.length === 0 && !showspinner
                                " class="No_data">
                                No Receipt Data Found
                              </h5>
                            </div>
                            <!-- pagination start -->
                            <div id="pagination" v-if="open_receipt.length > 10">
                              <ul class="pagination justify-content-center">

                                <!-- "Previous" Button -->
                                <li class="page-item" :class="receipt_current === 1 ? 'disabled' : ''">
                                  <a href="#" class="page-link" aria-label="Previous"
                                    @click.prevent="updateReceiptCurrent(receipt_current - 1)">
                                    Previous
                                  </a>
                                </li>

                                <!-- Pagination Links (Display 5 at a time) -->
                                <li v-for="page_index in receipt_paginate_total" :key="page_index.id" :class="[
                                  'page-item',
                                  receipt_current === page_index ? 'active' : ''
                                ]" v-if="page_index >= receipt_current - 2 && page_index <= receipt_current + 2">
                                  <a href="#" class="page-link" @click.prevent="updateReceiptCurrent(page_index)">
                                    {{ page_index }}
                                  </a>
                                </li>

                                <!-- "Next" Button -->
                                <li class="page-item" :class="receipt_current === receipt_paginate_total ? 'disabled' : ''
                                  ">
                                  <a href="#" class="page-link" aria-label="Next"
                                    @click.prevent="updateReceiptCurrent(receipt_current + 1)">
                                    Next
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <!-- pagination end -->
                          </div>
                        </div>
                      </div>
                      <!-- /recepit data -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <layout-footer></layout-footer>
    </div>
  </div>
</template>
    
<script>
// import upcomingpatients from "../../assets/json/doctor/upcomingpatients.json";
// import todaypatients from "../../assets/json/doctor/todaypatients.json";
import CommonApi from "@/services/CommonApi";
import config from "../../../services/CommonApi";
import { mapState } from "vuex";
const images = require.context("@/assets/img/patients");

export default {
  data() {
    return {
      // upcomingpatients: upcomingpatients,
      // todaypatients: todaypatients,
      config: config,
      open_receipt: [],
      showspinner: true,

      receipt_current: 1,
      receipt_paginate: 10,
      receipt_paginate_total: 0,
    };
  },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if(!user){
      this.$router.push({name:'login'})
    }
    this.get_receipt_data(),
      $(".progressresult").each(function () {
        const percentageToDegrees = (percentage) => {
          return (percentage / 100) * 360;
        };
        let value = $(this).attr("data-value");
        let left = $(this).find(".progress-left .progress-bar");
        let right = $(this).find(".progress-right .progress-bar");

        if (value > 0) {
          if (value <= 50) {
            right.css(
              "transform",
              "rotate(" + percentageToDegrees(value) + "deg)"
            );
          } else {
            right.css("transform", "rotate(180deg)");
            left.css(
              "transform",
              "rotate(" + percentageToDegrees(value - 50) + "deg)"
            );
          }
        }
      });
  },
  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
      user_type: (state) => state.user.user_type,
    }),
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      // const year = date.getFullYear();
      const year = date.getFullYear().toString().slice(-2);
      return `${day}-${month}-${year}`;
    },


    
    // pagination start
    setOpenReceipts(i) {
      if (this.receipt_current == 1) {
        return i < this.receipt_paginate;
      } else {
        return (
          i >= this.receipt_paginate * (this.receipt_current - 1) &&
          i < this.receipt_current * this.receipt_paginate
        );
      }
    },

    updateReceiptCurrent(i) {
      this.receipt_current = i;
      document.getElementById("patient_container").scrollIntoView();
    },
    //pagination end


    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    // /* Navigate to last Encounter  */
    // viewreceiptdata(patient_id) {
    //   this.$router.push(
    //     `/doctor/receipt-details/${patient_id}`
    //   );
    // },


    /* Get Open Patient Encounter List */
    get_receipt_data() {
      let data = {
        patient: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.api.get_patient_opd_receipts",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.open_receipt = res.data;
          this.receipt_paginate_total = Math.ceil(
              this.open_receipt.length / this.receipt_paginate
            );
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/kneexpert/patient/Receipt.vue